<script>
import Hotkey from 'dashboard/components/base/Hotkey.vue';
// PATCH ZERA: o simbolo de command da Apple estava cravado no template e aparecia para todo
// mundo, inclusive em Windows. O projeto ja tem deteccao de SO e usa no resto do app.
import { isApple } from 'shared/helpers/platform';

export default {
  components: {
    Hotkey,
  },
  data() {
    return {
      modKey: isApple() ? '\u2318' : 'Ctrl',
      keyShortcuts: [
        {
          key: 'K',
          description: this.$t('CONVERSATION.EMPTY_STATE.CMD_BAR'),
        },
        {
          key: '/',
          description: this.$t('CONVERSATION.EMPTY_STATE.KEYBOARD_SHORTCUTS'),
        },
      ],
    };
  },
};
</script>

<template>
  <div class="flex flex-col gap-2 mt-9">
    <div
      v-for="keyShortcut in keyShortcuts"
      :key="keyShortcut.key"
      class="flex items-center gap-2"
    >
      <div class="flex items-center gap-2">
        <Hotkey
          :custom-class="`${modKey === 'Ctrl' ? 'px-2 h-6 text-xs' : 'w-8 h-6 text-lg'} font-medium text-n-slate-12 outline outline-n-container outline-1 bg-n-alpha-3`"
        >
          {{ modKey }}
        </Hotkey>
        <Hotkey
          custom-class="w-8 h-6 text-xs font-medium text-n-slate-12 outline outline-n-container outline-1 bg-n-alpha-3"
        >
          {{ keyShortcut.key }}
        </Hotkey>
      </div>
      <span class="text-sm font-medium text-center text-n-slate-12">
        {{ keyShortcut.description }}
      </span>
    </div>
  </div>
</template>
